import script from "./EventCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./EventCarousel.vue?vue&type=style&index=0&id=bacdf260&lang=scss"

const __exports__ = script;

export default __exports__